module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main-slider"
  }, [_c('div', {
    staticClass: "slide bg-full overlay"
  }, [_c('div', {
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("Velkommen til P. Pedersen & Søn Ærø")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Fragt- og Vognmandsfirma")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f24d32a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/slider.vue
// module id = 260
// module chunks = 1